import type { NavigationItemType } from "../../root/layout/SidebarMenuItem";
import type { Paths } from "../../shared/usePrivacyNavigate";
import { measuresGridPageRoutes, prefetchMeasuresGridViewAndForm } from "./MeasuresGridPage";

export const route: NavigationItemType["route"] = { path: "measures", children: measuresGridPageRoutes };
export const to = (paths: Paths) => paths.measuresGrid();
export const prefetch = () => void prefetchMeasuresGridViewAndForm();
